import { create } from 'zustand';

/**
 * THE BOTTOM BAR'S CHECK-IN DISC, AND THE PUNCH IT NOW PERFORMS.
 *
 * The disc was `<NavLink to="/">`: on the home screen — the ONE screen the
 * punch lives on — it was a link to the page the reader was already standing
 * on. The most prominent control on the phone, in the thumb zone, wearing the
 * app's primary action's name, doing nothing. A worker tapped it and the app
 * did not move.
 *
 * The bar cannot punch by itself: the decision needs the camera gate, the
 * geofence, the mutation and the refusal copy, all of which live in
 * `CheckInPanel`. And the two are not in the same tree — the bar is chrome in
 * `AppShell`, the panel is inside the route — so a prop would have to be
 * threaded through the router to reach it.
 *
 * So the bar states an INTENT and the panel acts on it. A counter rather than a
 * boolean, deliberately: two taps in a row are two intents, and a boolean that
 * is already `true` swallows the second. Nothing here decides whether the punch
 * is allowed — `CheckInPanel` still owns every check it always did, and ignores
 * an intent it cannot honour.
 */
interface PunchIntentState {
  /** Bumped on every request. The panel acts on a CHANGE, never on a value. */
  requested: number;
  /** The bar's disc, tapped while the home screen is open. */
  request: () => void;
}

export const usePunchIntentStore = create<PunchIntentState>((set) => ({
  requested: 0,
  request: () => set((s) => ({ requested: s.requested + 1 })),
}));
